export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) =>
          registration.addEventListener('updatefound', () => {
            // If updatefound is fired, it means that there's
            // a new service worker being installed.
            const installingWorker = registration.installing
            if (!installingWorker) {
              // eslint-disable-next-line no-console
              console.log('No new service worker is being installed')
            } else {
              installingWorker?.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        )
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('No-op Service Worker registration failed:', error)
        })
    })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error)
      })
  }
}
